export { default } from './useLazyCSS';
